import BaseController from "./base_controller"

export default class extends BaseController {
  static outlets = ["design-system--command-palette-component"]

  handleClick(event) {
    this.designSystemCommandPaletteComponentOutlet.open(event)
  }
}
